import React from 'react';
import './locationdisplay.scss';

interface Props {
  locationName?: string;
  isPickup?: boolean;
  showArrow?: boolean;
  size?: string;
  color?: string;
  children?: React.ReactNode;
}

export const LocationDisplay = ({
  locationName,
  isPickup = false,
  showArrow = true,
  size = 'normal',
  color = 'blue',
  children,
}: Props): JSX.Element => {
  return (
    <div
      className={
        'location-display location-display--size-' +
        size +
        ' location-display--color-' +
        color +
        (isPickup ? ' location-display--a' : ' location-display--b') +
        (!showArrow ? ' location-display--hide-arrow' : '')
      }
    >
      <div className={'location-display--dot'} />
      {isPickup && <div className={'location-display--arrow'} />}
      {locationName && <h6 className="location-display--header">{locationName}</h6>}
      <div className={'-mt-1'}>{children}</div>
    </div>
  );
};

export default LocationDisplay;
